import { makeStyles } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import SchoolIcon from '@material-ui/icons/School';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import FlashOnIcon from '@material-ui/icons/FlashOn';
import CategoryIcon from '@material-ui/icons/Category';
import LogoFull from '../components/Root/LogoFull';
import {
  Settings as SidebarSettings,
  UserSettingsSignInAvatar,
} from '@backstage/plugin-user-settings';
import {
  Sidebar,
  sidebarConfig,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
  useSidebarOpenState,
  Link,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { compatWrapper } from '@backstage/core-compat-api';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: 3 * sidebarConfig.drawerWidthClosed,
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    marginBottom: -14,
  },
  link: {
    width: sidebarConfig.drawerWidthClosed,
    marginLeft: 24,
  },
});

const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        {isOpen ? <LogoFull /> : <LogoFull />}
      </Link>
    </div>
  );
};

// Paths placed explicitly in the sidebar — filter these from auto-discovered items
const explicitPaths = new Set([
  '/',
  '/search',
  '/create',
  '/catalog',
  '/learn',
  '/accelerators',
  '/settings',
  '/api-docs',
  '/docs',
]);

const navContent = NavContentBlueprint.make({
  params: {
    // compatWrapper is required because the Sidebar components from
    // @backstage/core-components and @backstage/plugin-user-settings still
    // depend on MUI v4 and legacy Backstage React contexts. It can be removed
    // once those packages ship MUI v5 / new-frontend-system-native versions.
    component: ({ items }) =>
      compatWrapper(
        <Sidebar>
          <SidebarLogo />
          <SidebarItem icon={SearchIcon} to="/search" text="Search" />
          <SidebarDivider />
          <SidebarGroup label="Menu" icon={<MenuIcon />}>
            {/* Global nav, not org-specific */}
            <SidebarItem icon={HomeIcon} to="/" text="Home" />
            <SidebarItem
              icon={FlashOnIcon}
              to="accelerators"
              text="Accelerators"
            />
            <SidebarItem icon={CategoryIcon} to="catalog" text="Catalog" />
            <SidebarItem icon={SchoolIcon} to="learn" text="Learn & Grow" />
            {/* Auto-discovered nav items from plugins */}
            <SidebarScrollWrapper>
              {items
                .filter(item => !explicitPaths.has(item.to))
                .map((item, index) => (
                  <SidebarItem key={index} {...item} />
                ))}
            </SidebarScrollWrapper>
          </SidebarGroup>
          <SidebarSpace />

          <SidebarDivider />
          <SidebarGroup
            label="Settings"
            icon={<UserSettingsSignInAvatar />}
            to="/settings"
          >
            <SidebarSettings />
          </SidebarGroup>
        </Sidebar>,
      ),
  },
});

export const navModule = createFrontendModule({
  pluginId: 'app',
  extensions: [navContent],
});
